import { theme } from 'antd';

export const antdTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    // Primary grey color (replacing purple)
    colorPrimary: '#6b7280',
    colorPrimaryHover: '#4b5563',
    colorPrimaryActive: '#374151',

    // Success/accent green
    colorSuccess: '#10b981',
    colorSuccessBg: 'rgba(16, 185, 129, 0.1)',
    colorSuccessBorder: '#10b981',

    // Error red
    colorError: '#ef4444',
    colorErrorBg: 'rgba(239, 68, 68, 0.1)',
    colorErrorBorder: '#ef4444',

    // Warning colors
    colorWarning: '#f59e0b',
    colorWarningBg: 'rgba(245, 158, 11, 0.1)',
    colorWarningBorder: '#f59e0b',

    // Info colors (grey-based)
    colorInfo: '#6b7280',
    colorInfoBg: 'rgba(107, 114, 128, 0.1)',
    colorInfoBorder: '#6b7280',

    // Background colors
    colorBgContainer: 'rgba(255, 255, 255, 0.05)',
    colorBgElevated: 'rgba(42, 42, 62, 0.5)',
    colorBgLayout: '#0f0f1e',
    colorBgSpotlight: 'rgba(107, 114, 128, 0.1)',

    // Text colors
    colorText: '#e0e0e0',
    colorTextSecondary: '#9ca3af',
    colorTextTertiary: '#6b7280',
    colorTextHeading: '#ffffff',

    // Border colors
    colorBorder: 'rgba(107, 114, 128, 0.3)',
    colorBorderSecondary: '#7a7a7a',

    // Border radius
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,

    // Typography
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: 16,
    fontSizeHeading1: 30,
    fontSizeHeading2: 20,
    lineHeight: 1.8,

    // Shadows (grey-based)
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    boxShadowSecondary: '0 8px 25px rgba(0, 0, 0, 0.4)',

    // Animation
    motionDurationMid: '0.3s',
  },
  components: {
    Card: {
      colorBgContainer: 'transparent',
      colorBorderSecondary: '#7a7a7a',
      boxShadowTertiary: '0 20px 60px rgba(0, 0, 0, 0.3)',
    },
    Input: {
      colorBgContainer: 'rgba(255, 255, 255, 0.05)',
      colorBorder: 'rgba(107, 114, 128, 0.3)',
      colorPrimaryHover: '#6b7280',
      activeShadow: '0 0 15px rgba(107, 114, 128, 0.3)',
    },
    Button: {
      colorPrimary: '#6b7280',
      colorPrimaryHover: '#4b5563',
      colorPrimaryActive: '#374151',
      primaryShadow: '0 8px 25px rgba(0, 0, 0, 0.4)',
    },
    Form: {
      labelColor: '#e0e0e0',
      labelFontSize: 14,
    },
    Typography: {
      colorTextHeading: '#ffffff',
      colorText: '#e0e0e0',
    },
    Alert: {
      colorSuccessBg: 'rgba(16, 185, 129, 0.1)',
      colorSuccessBorder: '#10b981',
      colorErrorBg: 'rgba(239, 68, 68, 0.1)',
      colorErrorBorder: '#ef4444',
      colorInfoBg: 'rgba(107, 114, 128, 0.1)',
      colorInfoBorder: '#6b7280',
      colorWarningBg: 'rgba(239, 68, 68, 0.1)',
      colorWarningBorder: '#ef4444',
    },
    Spin: {
      colorPrimary: '#6b7280',
    },
  },
};
